// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"CustomDropDownItem_labelWrapper__K4xve","active":"CustomDropDownItem_active__MctGr"};